var angular = require('angular');
var _module = angular.module('benoit');

_module.directive('ngRepeatFinished', [
    '$log',

    function ($log) {
        return {
            restrict: 'A',
            link: function ngRepeatFinishedLink($scope, elem, attrs) {
                if($scope.$last === true) {
                    $log.debug('ngRepeat Finished Rendering');
                    $scope.$evalAsync(attrs.ngRepeatFinished);
                }
            }
        };
    }
]);
